import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { Icon, Button } from 'antd';
import request from 'superagent';
import NotificationManager from '../../../commons/CustomNotificationManager.js';
import EditableCellNumber from './EditableCellNumber.js';
import EditableCellInput from './EditableCellInput.js';
import EditableCellSelect from './EditableCellSelect.js';
import AlertConfigurationServiceMsgConfirm from './AlertConfigurationServiceMsgConfirm.js';
import AlertConfigurationDeleteConfirm from './AlertConfigurationDeleteConfirm.js';

class AlertConfigurationServiceMessage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: [],
            threshholdList: [],
            showServiceAlert: '',
            saData: [],
            originThreshholdList: [],
            showSave: false
        };
    }

    componentDidMount() {
        let originThreshholdList = JSON.parse(JSON.stringify(this.props.threshholdList));
        let threshholdList = this.props.threshholdList;
        let showServiceAlert = this.props.showServiceAlert;
        let saData = this.props.saData;
        this.setState({
            selected: [],
            threshholdList: threshholdList,
            showServiceAlert: showServiceAlert,
            saData: saData,
            originThreshholdList: originThreshholdList,
            showSave: false
        });
    }

    componentWillReceiveProps(nextProps) {
        let originThreshholdList = JSON.parse(JSON.stringify(nextProps.threshholdList));
        let threshholdList = nextProps.threshholdList;
        let showServiceAlert = nextProps.showServiceAlert;
        let saData = nextProps.saData;
        this.setState({
            selected: [],
            threshholdList: threshholdList,
            showServiceAlert: showServiceAlert,
            saData: saData,
            originThreshholdList: originThreshholdList,
            showSave: false
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        let threshholdList = this.state.threshholdList;
        let saData = this.state.saData;
        let showServiceAlert = this.state.showServiceAlert;
        for (let i = 0; i < saData.length; i++) {
            if (saData[i].index === showServiceAlert) {
                saData[i].threshhold = threshholdList;
                break;
            }
        }
        let data = {saData: saData};
        request.post('/api/dashboard/alert/configuration/serviceSave')
            .withCredentials()
            .set('Content-Type', 'application/json; charset=utf-8')
            .send(data)
            .end((error, response) => {
                if (!error && response) {
                    this.props.onSuccess();
                    let originThreshholdList = JSON.parse(JSON.stringify(threshholdList));
                    this.setState({
                        selected: [],
                        threshholdList: threshholdList,
                        showServiceAlert: showServiceAlert,
                        saData: saData,
                        originThreshholdList: originThreshholdList,
                        showSave: false
                    });
                    this.refs.table.reset();
                    NotificationManager.success('Succeed to save configuration.');
                } else {
                    //console.error("Error while save configuration.", error);
                    NotificationManager.error('Failed to save configuration.');
                }
            });
    }

    createCustomToolBar = props => {
        const selected = this.state.selected;
        return (
            <div>
                <div className='buttonFiled'>
                    <div className="toolBar" style={{display: 'flex'}}>
                        <Button onClick={this.onAdd} className="btn btn-add" title="Add">
                            <i title="Add"></i>Add
                        </Button>
                        <Button onClick={this.openDeleteModal} className="btn delete-icon" title="Delete" disabled={selected.length <= 0}>
                            <i title="Delete"></i>Delete
                        </Button>
                        <div style={{display: this.state.showSave ? 'block' : 'none'}}>
                            <AlertConfigurationServiceMsgConfirm handleSubmit={this.handleSubmit}/>
                        </div>
                    </div>
                </div>
                <div className='searchFiled'>
                    { props.components.searchPanel }
                </div>
            </div>
        );
    }

    inputTextFormatter = (cell, row, enumObject, rowIndex) => {
        return (
            <div>
                <div className="editable-cell-text-wrapper"> {cell}
                    <Icon type="edit" className="editable-cell-icon" onClick={this.edit}/>
                </div>
            </div>
        );
    }

    onAdd = () => {
        let threshholdList = this.state.threshholdList;
        const newData = {
            key: threshholdList.length,
            serviceType: '',
            msgName: '',
            warning: '',
            alarm: '',
            resolve: '',
            notification: ''
        };
        this.setState({threshholdList: [...threshholdList, newData], selected: []});
        this.checkDataChange([...threshholdList, newData]);
        this.refs.table.reset();
    }

    onDelete = () => {
        const selected = this.state.selected;
        if (selected.length === 0) {
            return;
        }
        let threshholdList = this.state.threshholdList;
        for (let i = 0; i < selected.length; i++) {
            threshholdList = threshholdList.filter(item => item.key !== selected[i]);
        }
        for (let i = 0; i < threshholdList.length; i++) {
            threshholdList[i].key = i;
        }
        this.setState({threshholdList: threshholdList});
        this.setState({selected: []});
        this.checkDataChange(threshholdList);
        this.refs.table.reset();
    }

    openDeleteModal = () => {
        this.deleteModal.open();
    }

    onRowSelect = (row, isSelected, e) => {
        let tmp = this.state.selected;
        if (isSelected) {
            tmp.push(row.key);
            this.setState({selected: tmp});
        } else {
            const index = tmp.indexOf(row.key);
            if (index > -1) {
                tmp.splice(index, 1);
                this.setState({selected: tmp});
            }
        }
    }

    onSelectAll = (isSelected, rows) => {
        if (!isSelected) {
            this.setState({ selected: [] });
        } else {
            this.setState({ selected: rows.map(e => e.key)});
        }
    }

    checkDataChange = (data) => {
        let originThreshholdList = this.state.originThreshholdList;
        if (data.length !== originThreshholdList.length) {
            this.setState({showSave: true});
            return;
        }
        for (let i = 0; i < data.length; i++) {
            let keyArray = Object.keys(data[i]);
            for (let j = 0; j < keyArray.length; j++) {
                let key = keyArray[j];
                if (data[i][key] !== originThreshholdList[i][key]) {
                    this.setState({showSave: true});
                    return;
                }
            }
        }
        this.setState({showSave: false});
        return;
    }

    afterSaveCell = (row, cellName, cellValue) => {
        let threshholdList = this.state.threshholdList;
        this.checkDataChange(threshholdList);
    }

    render() {
        const threshholdList = this.state.threshholdList;
        const options = {
            defaultSortName: 'key',
            defaultSortOrder: 'asc',
            toolBar: this.createCustomToolBar,
            noDataText: 'No threshold found.',
            searchDelayTime: 500
        };
        const cellEditProp = {
            mode: 'click',
            afterSaveCell: this.afterSaveCell,
        };
        const selectRowProp = {
            mode: 'checkbox',
            bgColor: '#f1f1f1',
            onSelect: this.onRowSelect,
            onSelectAll: this.onSelectAll
        };
        const selectOptions = [
            'pagerduty service1',
            'pagerduty service2',
            'teams'
        ];
        const createCellNumber = (onUpdate, props) => (<EditableCellNumber onUpdate={ onUpdate } {...props}/>);
        const createCellInput = (onUpdate, props) => (<EditableCellInput onUpdate={ onUpdate } {...props}/>);
        const createCellSelect = (onUpdate, props) => (<EditableCellSelect onUpdate={ onUpdate } {...props}/>);

        return (
            <div>
                <BootstrapTable ref="table" data={ threshholdList } search={ true } options={ options } cellEdit={ cellEditProp } selectRow={ selectRowProp } striped hover condensed>
                    <TableHeaderColumn dataField='key' isKey
                                       dataSort={ true } width="4%"></TableHeaderColumn>
                    <TableHeaderColumn dataField='serviceType' dataFormat={this.inputTextFormatter}
                                       customEditor={ {getElement: createCellInput,customEditorParameters: {fieldName: 'serviceType'}} }
                                       dataSort={ true } width="25%">Service Type</TableHeaderColumn>
                    <TableHeaderColumn dataField='msgName' dataFormat={this.inputTextFormatter}
                                       customEditor={ {getElement: createCellInput,customEditorParameters: {fieldName: 'msgName'}} }
                                       dataSort={ true } width="25%">Message Name</TableHeaderColumn>
                    <TableHeaderColumn dataField='warning' dataFormat={this.inputTextFormatter}
                                       customEditor={ {getElement: createCellNumber,customEditorParameters: {fieldName: 'warning'}} }
                                       dataSort={ true } width="10%">Warning</TableHeaderColumn>
                    <TableHeaderColumn dataField='alarm' dataFormat={this.inputTextFormatter}
                                       customEditor={ {getElement: createCellNumber,customEditorParameters: {fieldName: 'alarm'}} }
                                       dataSort={ true } width="10%">Alarm</TableHeaderColumn>
                    <TableHeaderColumn dataField='resolve' dataFormat={this.inputTextFormatter}
                                       customEditor={ {getElement: createCellNumber,customEditorParameters: {fieldName: 'resolve'}} }
                                       dataSort={ true } width="10%">Resolve</TableHeaderColumn>
                    <TableHeaderColumn dataField='notification' dataFormat={this.inputTextFormatter}
                                       customEditor={ {getElement: createCellSelect,customEditorParameters: {fieldName: 'notification', options: {selectOptions}}} }
                                       dataSort={ true } width="16%">Notification</TableHeaderColumn>
                </BootstrapTable>
                <AlertConfigurationDeleteConfirm ref={modal => { this.deleteModal = modal }} onSuccess={this.onDelete}/>
            </div>
        );
    }
}
export default AlertConfigurationServiceMessage;


// WEBPACK FOOTER //
// ./src/modules/dashboard/alert-configuration/AlertConfigurationServiceMessage.js